collections.service('BaseCollection', [
    function () {

        function BaseCollection(items) {
            var entities = items || [];

            this.add = function (item) {
                entities.push(item);
            };

            this.get = function (rule) {
                return _.find(entities, rule);
            };

            this.find = function (rule) {
                return _.filter(entities, rule);
            };

            this.findBy = function(rule, comparator, sort) {
                const items = _.chain(entities)
                    .filter(rule)
                    .filter(comparator);

                const result = sort ? items.orderBy(sort.field, sort.dir) : items;
                return result.value();
            };

            this.sort = function (rule) {
                return _.orderBy(entities, rule);
            };

            this.remove = function (rule) {
                return _.remove(entities, rule);
            };

            this.getAll = function () {
                return entities;
            };

            this.length = function () {
                return entities.length;
            };

            this.fill = function (data) {
                entities = data;
            };

            this.clear = function () {
                entities = [];
            }
        }

        return BaseCollection;
    }
]);
